import React from 'react';

export default function AtividadesPage() {
  return (
    <div>
      Qualidade - Atividades (placeholder).
    </div>
  );
}

